<template>
  <v-dialog :value="value" max-width="560" @input="$emit('input', $event)" persistent>
    <v-card>
      <v-card-title class="headline">
        Add custom task
      </v-card-title>
      <v-card-text>
        <v-text-field
          outlined
          dense
          label="Title"
          hide-details="auto"
          color="greenColor"
          v-model="title"
          maxlength="255"
          autofocus
          class="mb-3"
        ></v-text-field>
        <v-textarea
          outlined
          dense
          rows="4"
          label="Description (optional)"
          hide-details="auto"
          color="greenColor"
          v-model="description"
          class="mb-3"
        ></v-textarea>
        <v-menu
          v-model="dueDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              outlined
              dense
              label="Due date (optional)"
              prepend-inner-icon="event"
              hide-details="auto"
              color="greenColor"
              :value="dueDate"
              readonly
              clearable
              v-bind="attrs"
              v-on="on"
              @click:clear="dueDate = ''"
              class="mb-3"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dueDate"
            @input="dueDateMenu = false"
          ></v-date-picker>
        </v-menu>
        <v-autocomplete
          v-if="assigneeOptions && assigneeOptions.length"
          outlined
          dense
          :items="assigneeOptions"
          item-text="label"
          item-value="value"
          label="Assignee (optional)"
          hide-details="auto"
          color="greenColor"
          v-model="assignedTo"
          clearable
        ></v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close" :disabled="submitting">Cancel</v-btn>
        <v-btn
          color="profileAnchorColor"
          class="whiteColor--text"
          rounded
          :loading="submitting"
          :disabled="!title.trim()"
          @click="submit"
        >
          Add task
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AddCustomTaskModal",
  props: {
    value: { type: Boolean, default: false },
    pageId: { type: Number, default: 0 },
    siteId: { type: Number, default: 0 },
    assigneeOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      title: "",
      description: "",
      dueDate: "",
      assignedTo: null,
      dueDateMenu: false,
      submitting: false,
    };
  },
  watch: {
    value(open) {
      if (open) this.reset();
    },
  },
  methods: {
    reset() {
      this.title = "";
      this.description = "";
      this.dueDate = "";
      this.assignedTo = null;
      this.submitting = false;
    },
    close() {
      this.$emit("input", false);
    },
    async submit() {
      const title = this.title.trim();
      if (!title) return;
      const payload = {
        title,
        description: this.description || "",
        source: "user",
      };
      if (this.pageId) payload.pageId = this.pageId;
      if (this.siteId) payload.siteId = this.siteId;
      if (this.dueDate) {
        payload.dueDate = new Date(this.dueDate).getTime();
      }
      if (this.assignedTo) payload.assignedTo = this.assignedTo;
      this.submitting = true;
      try {
        const response = await this.$store.dispatch("addCustomTask", payload);
        const body = response && response.data;
        if (body && body.status === "SUCCESS") {
          this.$notify({
            group: "info",
            type: "success",
            text: "Custom task added.",
          });
          this.$emit("created", body.task);
          this.close();
        } else {
          this.$notify({
            group: "info",
            type: "error",
            text: (body && body.msg) || "Failed to add task.",
          });
        }
      } catch (e) {
        this.$notify({
          group: "info",
          type: "error",
          text: "Failed to add task.",
        });
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
